exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flash[data-v-3541a4ab]{position:absolute;z-index:99999999;left:8px;right:8px;bottom:8px;border:1px solid #000}.flash[data-v-3541a4ab]:hover{cursor:pointer}.flash .message[data-v-3541a4ab]{padding:8px}.flash .icon.close[data-v-3541a4ab]{font-size:1.5em}", ""]);

// exports
